// Países disponíveis na inscrição do torneio (bandeira em public/bandeira_<sigla>.png).
export const countries = [
  // América do Sul
  { value: "AR", label: "Argentina" },
  { value: "BO", label: "Bolívia" },
  { value: "BR", label: "Brasil" },
  { value: "CL", label: "Chile" },
  { value: "CO", label: "Colômbia" },
  { value: "EC", label: "Equador" },
  { value: "GY", label: "Guiana" },
  { value: "PY", label: "Paraguai" },
  { value: "PE", label: "Peru" },
  { value: "SR", label: "Suriname" },
  { value: "UY", label: "Uruguai" },
  { value: "VE", label: "Venezuela" },
  // Europa
  { value: "AL", label: "Albânia" },
  { value: "DE", label: "Alemanha" },
  { value: "AD", label: "Andorra" },
  { value: "AM", label: "Armênia" },
  { value: "AT", label: "Áustria" },
  { value: "BY", label: "Bielorrússia" },
  { value: "BE", label: "Bélgica" },
  { value: "BA", label: "Bósnia e Herzegovina" },
  { value: "BG", label: "Bulgária" },
  { value: "HR", label: "Croácia" },
  { value: "DK", label: "Dinamarca" },
  { value: "SK", label: "Eslováquia" },
  { value: "SI", label: "Eslovênia" },
  { value: "ES", label: "Espanha" },
  { value: "EE", label: "Estônia" },
  { value: "FI", label: "Finlândia" },
  { value: "FR", label: "França" },
  { value: "GE", label: "Geórgia" },
  { value: "GR", label: "Grécia" },
  { value: "HU", label: "Hungria" },
  { value: "IS", label: "Islândia" },
  { value: "IT", label: "Itália" },
  { value: "XK", label: "Kosovo" },
  { value: "LV", label: "Letônia" },
  { value: "LI", label: "Liechtenstein" },
  { value: "LT", label: "Lituânia" },
  { value: "LU", label: "Luxemburgo" },
  { value: "MT", label: "Malta" },
  { value: "MD", label: "Moldávia" },
  { value: "MC", label: "Mônaco" },
  { value: "ME", label: "Montenegro" },
  { value: "NO", label: "Noruega" },
  { value: "NL", label: "Países Baixos" },
  { value: "PL", label: "Polônia" },
  { value: "PT", label: "Portugal" },
  { value: "UK", label: "Reino Unido" },
  { value: "CZ", label: "República Tcheca" },
  { value: "RO", label: "Romênia" },
  { value: "RU", label: "Rússia" },
  { value: "SM", label: "San Marino" },
  { value: "RS", label: "Sérvia" },
  { value: "SE", label: "Suécia" },
  { value: "CH", label: "Suíça" },
  { value: "UA", label: "Ucrânia" },
  { value: "VA", label: "Vaticano" },
];

export default countries;
